import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { CompanyService } from '../../services/company.service';
import { CommonModule } from '@angular/common';
import { finalize, forkJoin } from 'rxjs';
import { Messages } from '../../../common/constants/messages';
import { FormsModule } from '@angular/forms';
import { W9StateService } from '../../../common/services/W9StateService';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-business-verification',
  imports: [CommonModule, TableModule, NgxSpinnerModule, DialogModule, FormsModule],
  templateUrl: './business-verification.component.html',
  styleUrl: './business-verification.component.css'
})
export class BusinessVerificationComponent {

  w9List: any[] = [];   
  loading = false;
  modalDlg = false;
  dialogSummary = '';
  dialogMsg = '';
  initialw9List: any[] = []; 
  statusList = [
      { value: 1, name: 'Pending' },
      { value: 2, name: 'Approved' },
      { value: 3, name: 'Rejected' },
      { value: 4, name: 'Expired' }
    ];

  constructor(    
    private companyService: CompanyService,
    private router: Router,
    private ngx: NgxSpinnerService,
    private w9State: W9StateService,      
    private headerService: HeaderService,
  ) { }

  /* ================= INIT ================= */

  ngOnInit(): void {  
    sessionStorage.removeItem('replaceW9CompanyId');  
    this.verifyToken();  
  }

   verifyToken()
  {
      let companyName = sessionStorage.getItem('companyName');
        if (companyName)
        {
          this.headerService.setCompanyName(companyName);
          this.getW9List();
        }
        else {
          const returnUrl = this.router.url;
          console.log(returnUrl);
          this.router.navigate(
            ['/login'],
            {
              queryParams: {
                returnUrl: returnUrl
              }
            }
          );
        }
  }

  goToReplaceW9(w9: any) {
  this.w9State.setCompanyId(w9.companyId);
  this.router.navigate(['/replace-w9']);
}

  getStatusList(status: string)
  {    
    switch(status)
    {
      case '1':
        return [
      { value: 1, name: 'Pending' },
      { value: 2, name: 'Approved' },
      { value: 3, name: 'Rejected' }     
    ];
        break;

      case '2':
         return [      
      { value: 2, name: 'Approved' },      
      { value: 4, name: 'Expired' }
    ];
        break;

      case '3':
         return [      
      { value: 3, name: 'Rejected' },
      { value: 4, name: 'Expired' }
    ];
          break;

      case '4':
          return [    
      { value: 4, name: 'Expired' }
    ];
        break;
    }

return [
      { value: 1, name: 'Pending' },
      { value: 2, name: 'Approved' },
      { value: 3, name: 'Rejected' },
      { value: 4, name: 'Expired' }
    ];
  }

  getW9List(): void {
      this.ngx.show()
      forkJoin({
        w9List: this.companyService.getW9NotApprovedList()        
      })
        .pipe(
          finalize(() => this.ngx.hide())
        )
        .subscribe({
          next: (res) => {
            this.w9List = res.w9List; 
            this.initialw9List = JSON.parse(JSON.stringify(res.w9List));        
          },
          error: (err) => {
            this.dialogSummary = Messages.ErrorTitle;
            this.dialogMsg = Messages.ErrorInAPICall;
            this.modalDlg = true;
          }
        });
    }

   cancel(): void {
    this.router.navigate(['/home']);
  }

  okClicked() {
    this.modalDlg = false;   
    this.getW9List(); 
  }

  downloadFile(fileName: string)
  {
    const payload = {
      fileName: fileName,
      containerType: "3"
    }

    this.ngx.show();
    this.loading = true;

    this.companyService.downloadFile(payload)
      .subscribe(
        {
          next: (blob) => {
            this.ngx.hide();
            this.loading = false;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);
          },

          error: (err) => {
            this.ngx.hide();
            this.loading = false;
            this.dialogSummary = Messages.ErrorTitle;
            this.dialogMsg = "Download Failed";
            this.modalDlg = true;
          }
        });
  }

  submit() {
   if(JSON.stringify(this.w9List) === JSON.stringify(this.initialw9List))
   {
            this.dialogSummary = Messages.ValidationTitle;
            this.dialogMsg = "Please change at least one status before submitting.";
            this.modalDlg = true;
            return;
   }

    this.ngx.show();
    this.loading = true;  

  this.companyService.updateW9Status(this.w9List).subscribe({
      next: () => {
        this.ngx.hide();
        this.loading = false;        
        this.dialogSummary = Messages.SuccessTitle;
        this.dialogMsg = Messages.W9SuccessMessage;
        this.modalDlg = true;              
      },
      error: (err) => {
        this.ngx.hide();
        this.loading = false;
        this.dialogSummary = Messages.ErrorTitle;
        this.dialogMsg = Messages.SaveFailedMessage;
        this.modalDlg = true;
      }
    });
}

goToAccountSettings(w9: any): void {
    this.router.navigate(['/account-settings/' + w9.companyId]);
}

}
